module.exports = __webpack_public_path__ + "images/apple_icon_a55e688.svg";